<app-page>
    <div class="electronics-page col-12 m-auto py-4 p-0">
        <div role="alert" *ngIf="errorMessage">
            <p-message class="plain-message" [severity]="errorMessage.severity" (onClose)="clearErrorMessage()"
                [icon]="errorMessage.icon" styleClass="mb-4 p-2" closable [ariaInjector]="[{
                    selector: '.p-message-close-button',
                    ariaLabel: 'Error message - close button',
                    role: 'button'
        }]">
                <p class="mb-2 mt-0">Error</p><span role="Error" aria-live="polite"
                    [innerHtml]="errorMessage.text"></span>
            </p-message>
        </div>
        <!-- HERO SECTION -->
        <div class="flex flex-column sm:flex-row align-items-center p-0 bg-slate-700 text-white">
            <div class="col-12 sm:col-6 lg:col-4 p-0 hero-image">
                <img src="assets/icons/cross-sell.svg" alt="cross-sell-image" />
            </div>

            <div *ngIf="contentToBeDisplayed" class="col-12 sm:col-6 lg:col-8 p-3">
                <p class="offer-text"> <i class="pi pi-bolt mr-1"></i> {{ contentToBeDisplayed.title}}</p>

                <h1 class="m-0 mb-2">{{ contentToBeDisplayed.hint }}</h1>

                <p>
                    {{ contentToBeDisplayed.description }}
                </p>
            </div>
        </div>

        <!-- CONTENT SECTION -->
        <div
            class="justify-content-center bg-slate-100 content flex flex-column gap-2 lg:gap-5 lg:flex-row px-3 py-3 lg:py-6">
            <!-- LEFT COLUMN -->

            <!-- VERSION A - Why Choose & Pricing & Actions -->
            <div class="col-12 lg:col-5">
                <h1 class="m-0 mb-2">{{ content.content.title }}
                </h1>

                <p class="text-slate-700">
                    {{ content.content.description }}
                </p>

                <div *ngIf="!isSpecialMemberOfferFormUrl">
                    <div *ngIf="loading" class="flex justify-content-center align-items-center">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <ng-container *ngIf="!loading">
                        <div class="mt-3 mb-2 flex flex-column" *ngIf="monthlyCost !== null">
                            <span class="font-bold text-slate-900">{{ monthlyCost | currency }} per month †</span>
                        </div>

                        <div class="flex flex-column gap-3">
                            <div *ngIf="contentToBeDisplayed" class="flex flex-column gap-3 w-full">
                                <p-button severity="primary" data-auto-id="cross-sell-enroll-init-button"
                                    [rounded]="true" styleClass="w-full text-base font-semibold px-6 py-3 shadow-button"
                                    [label]="content.cta.buttonText" (click)="goToEnroll()">
                                </p-button>
                            </div>
                        </div>
                    </ng-container>

                </div>

                <!-- VERSION B - Form -->
                <div id="special-member-offer-form" *ngIf="isSpecialMemberOfferFormUrl" class="mt-4"
                    [ngClass]="{'border-top-1 pt-4 border-slate-200': !isSpecialMemberOfferFormUrl}">
                    <app-special-member-offer-form></app-special-member-offer-form>
                </div>
            </div>

            <!-- RIGHT COLUMN (Features Checklist) -->
            <div class="col-12 lg:col-6 flex flex-column justify-content-center">
                <div class="w-full">
                    <ul class="flex flex-column list-style-none pl-0">
                        <li *ngFor="let feature of content.content.features" class="mb-3 flex align-items-center gap-3">
                            <span
                                class="check-badge flex justify-content-center align-items-center border-circle bg-green-700 text-white">
                                <i class="pi pi-check"></i>
                            </span>
                            <span class="text-slate-700">{{ feature }}</span>
                        </li>
                    </ul>
                    <div class="pl-1" *ngIf="!isSpecialMemberOfferFormUrl">
                        <button type="button" (click)="openSampleContract()"
                            class="sample-contract-link text-blue-500 underline text-sm cursor-pointer border-none bg-transparent p-0 text-left">{{
                            content.content.sampleContractText }}</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- HOW IT WORKS -->
        <div class="text-center bg-white md:p-8 px-4 py-4 lg:py-6">
            <h2>{{ content.stepsSection.title }}</h2>
            <p class="sub">{{ content.stepsSection.subtitle }}</p>

            <div class="flex flex-column md:flex-row align-items-center mt-5 justify-content-center">
                <div *ngFor="let step of content.stepsSection.steps" class="col-12 md:col-4 text-center px-5">
                    <div class="step-circle">{{ step.step }}</div>
                    <h4>{{ step.title }}</h4>
                    <p>{{ step.description }}</p>
                </div>
            </div>
        </div>

        <!-- CTA -->
        <div *ngIf="contentToBeDisplayed && contractData" class="bg-slate-700 text-center py-4 lg:py-6 px-5 text-white">
            <div *ngIf="isSpecialMemberOfferFormUrl">
                <h2 class="m-0">Ready to protect your home electronics?</h2>
                <p class="my-4">Help protect the electronics you use every day with coverage starting at $19.99 per
                    month. Terms apply.</p>
                <p-button severity="primary" data-auto-id="cross-sell-call-me-button" [rounded]="true"
                    (click)="scrollToForm()" class="w-full"
                    styleClass="text-base w-full sm:w-10 md:w-8 lg:w-5 white-space-nowrap shadow-button mb-2"
                    label="Get Started">
                </p-button>
            </div>

            <!-- Enrollment flow CTA -->
            <div *ngIf="!isSpecialMemberOfferFormUrl && !loading">
                <h2 class="m-0">{{ content.cta.title }}</h2>
                <p class="my-4">{{ ctaDescription }}</p>

                <p-button severity="primary" data-auto-id="cross-sell-enroll-init-button" [rounded]="true"
                    class="w-full"
                    styleClass="text-base w-full sm:w-10 md:w-8 lg:w-5 white-space-nowrap shadow-button mb-2"
                    [label]="content.cta.buttonText" (click)="goToEnroll()">
                </p-button>
            </div>
        </div>

        <!-- TnC -->
        <div class="pt-4 lg:pt-6 px-5 text-slate-600">
            <p class="m-0">{{content.tnc.title}}</p>
            <p class="m-0 mt-5">{{ content.tnc.description }}</p>
        </div>

    </div>
</app-page>